export const WalkerPedestrian = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M26 15H21L19.5029 11.2572C19.1992 10.4979 18.4637 10 17.6459 10H13.831C13.2872 10 12.7537 10.1478 12.2875 10.4275L8 13V18" stroke="currentColor" stroke-width="2"/>
<path d="M9.5 29.5L13 24V10" stroke="currentColor" stroke-width="2"/>
<path d="M18 18L20 24V30" stroke="currentColor" stroke-width="2"/>
<circle cx="16.5" cy="4.5" r="2.5" stroke="currentColor" stroke-width="2"/>
</svg>`;
